import { MIXINS } from "@/utils/mixins"

const state = {
  currentLeague: "",
  currentDivision: "",
  showEstimator: false,
  showEditor: false,
  leagueOptionsShow: false,
  divisionOptionsShow: false,
  estimatorUpdated: false,
}

const getters = {
  currentLeague: state => state.currentLeague,
  currentDivision: state => state.currentDivision,
  showEstimator: state => state.showEstimator,
  showEditor: state => state.showEditor,
  leagueOptionsShow: state => state.leagueOptionsShow,
  divisionOptionsShow: state => state.divisionOptionsShow,
  estimatorUpdated: state => state.estimatorUpdated,
}

const mutations = {
  setCurrentLeague: (state, league) => (state.currentLeague = league),
  setCurrentDivision: (state, division) => (state.currentDivision = division),
  setLeagueOptionsShow: (state, leagueOptionsShow) => (state.leagueOptionsShow = leagueOptionsShow),
  setDivisionOptionsShow: (state, divisionOptionsShow) => (state.divisionOptionsShow = divisionOptionsShow),
  setShowEstimator: (state, showEstimator) => (state.showEstimator = showEstimator),
  setShowEditor: (state, showEditor) => (state.showEditor = showEditor),
  setEstimatorUpdated: (state, estimatorUpdated) => (state.estimatorUpdated = estimatorUpdated),
}

const actions = {
  updateLeague ({ commit, state }, league) {
    if (state.currentLeague !== league) {
      commit("setEstimatorUpdated", true)
    }
    this.currentLeague = league
    commit("setCurrentLeague", league)
    commit("setLeagueOptionsShow", false)
  },
  updateDivision ({ commit }, division) {
    if (state.currentDivision !== division) {
      commit("setEstimatorUpdated", true)
    }
    commit("setCurrentDivision", division)
    commit("setDivisionOptionsShow", false)
  },
  updateRank ({ commit }) {
    commit("setShowEditor", false)
    setTimeout(() => {
      commit("setShowEstimator", true)
    }, 500)
  },
  edit ({ commit }) {
    MIXINS.methods.trackAnalyticsEvent("Modify rank")
    commit("setShowEditor", true)
    commit("setShowEstimator", false)
  },
  hideOptions ({ commit }) {
    commit("setLeagueOptionsShow", false)
    commit("setDivisionOptionsShow", false)
  },
  async getCurrentRank ({ commit, dispatch, rootGetters }, gameId) {
    try {
      await dispatch("Onboarding/getGameSpecificPersonas", gameId, { root: true })
      const currentRank = rootGetters["Onboarding/gamePersona"].current_rank.split(" ")
      if (currentRank) {
        commit("setCurrentLeague", currentRank[0].toLowerCase())
        commit("setCurrentDivision", currentRank[1].toLowerCase())
      } else {
        dispatch("edit")
      }
    } catch (error) {
      dispatch("edit")
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/estimator.js